import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    border: theme.card.border,
    borderBottomWidth: theme.card.borderBottomWidth,
    '& div.card-header': {
      minHeight: 'inherit'
    },
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  header: {
    //backgroundColor: theme.backgroundColor
    position: 'relative'
  },
  refreshButton: {
    position: 'absolute',
    top: 0,
    right: 0
  },
  loading: {
    textAlign: 'center'
  },
  body: {
    padding: 5
  }
}))

export {
  useStyles
}
